import React, { useState } from "react";
import { FaPenSquare, FaQuestionCircle } from "react-icons/fa";
import { AuthServices } from "../services/AuthServices";
import { useNavigate } from "react-router-dom";
import useUpdateOnboardingStatus from "../../../utils/hooks/useUpdateOnboardingStatus";

const StoreOperationMore = ({ setStep }) => {
  const [formData, setFormData] = useState({});
  const updateOnboardingStatus = useUpdateOnboardingStatus();
  const [toolTip, setToolTip] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleMouseEnter = () => {
    setToolTip(true);
  };

  const handleMouseLeave = () => {
    setToolTip(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await AuthServices.updateDeliveryInstructions(formData);
    if (!response.success) {
      setMessage("This number is already in our database.");
    }

    const updateStatus = await updateOnboardingStatus("storeOperationsMore");
    if (!updateStatus) {
      setMessage("This number is already in our database.");
      return;
    }

    setStep(5);
  };

  return (
    <div className="store-hours-container">
      <div className="header">
        <div className="icon">
          <FaPenSquare />
        </div>
        <h1>Pick Up Instructions</h1>
        <p>Must be at least 8 words</p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="pickup-instructions">
          <label htmlFor="instructions" className="tooltip-container">
            Pickup Instructions
            <FaQuestionCircle
              className="tooltip-icon"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
            <span className={`tooltip-text ${toolTip ? "show" : ""}`}>
              Enter the pickup instructions for the delivery drivers.
            </span>
          </label>

          <textarea
            onChange={handleChange}
            placeholder="Park on level 2 of the garage enter through Macy's and receive package."
            name="instructions"
            id="instructions"
            rows={6}
          ></textarea>
        </div>
        <div className="">
          <label htmlFor="tel">Customer Service Number</label>
          <input
            required
            placeholder="888-222-1111"
            type="tel"
            name="tel"
            id="tel"
            pattern="^\d{10}$"
            onChange={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
              handleChange(e);
            }}
          />
        </div>
        <div>
          <label htmlFor="website">Website</label>
          <input
            placeholder="www.example.com"
            type="text"
            name="website"
            id="website"
            onChange={handleChange}
            pattern="www\.[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
            title="Please enter a valid website URL (must start with www.)"
            required
          />
        </div>
        {message && <p className="error-message">{message}</p>}
        <button className="continue-btn">Continue</button>
      </form>
    </div>
  );
};

export default StoreOperationMore;
